/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { EventBusModule } from '@common/event-bus-module';

import { CREATE_POLICY } from '@pages/BuyInsurancePage/apis/graphql';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { vappContainer } from '@/application';

import { FIAT_RAZORPAY_TX_ERROR } from './create-order.plugin';

export interface IDisplayRazorPayProps {
  order?: any;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

const eventBus = () => {
  return vappContainer.get<EventBusModule>(EventBusModule.displayName);
};

export interface IDisplayRazorPayMethods extends IPluginMethodMap {
  getDisplayRazorPayProps(args: IDisplayRazorPayProps): Promise<any>;
}

export class DisplayRazorPayPlugin implements IAgentPlugin {
  readonly methods: IDisplayRazorPayMethods;

  constructor() {
    this.methods = {
      getDisplayRazorPayProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IDisplayRazorPayProps) {
    console.log(`args in display razor`, args);
    //   return await this.submitKyc(args);
    const res = await this.loadScript(apiConfig?.scriptURL);

    if (!res) {
      throw Error('Are you online?');
    }
    //@ts-ignore
    const paymentObject = new window.Razorpay(args?.order);
    paymentObject?.on('payment.failed', (response: any) => {
      eventBus()?.getEventBus()?.emit(FIAT_RAZORPAY_TX_ERROR, null, {
        message: response.error?.reason,
      });

      // alert(response.error.code);
      // alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
    });
    paymentObject.open();
  }

  private loadScript(src: any) {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }
}
